'use client';

import React, { useState } from 'react';
import WizardStep1Input from './WizardStep1Input';
import WizardStep2Configure from './WizardStep2Configure';
import WizardStep3Generate from './WizardStep3Generate';

const steps = [
  { id: 'step-input', num: 1, label: 'Input', desc: 'Inhalt eingeben' },
  { id: 'step-config', num: 2, label: 'Konfiguration', desc: 'Plattformen & Ton' },
  { id: 'step-generate', num: 3, label: 'Generieren', desc: '14-Tage-Kalender' },
];

export interface WizardData {
  inputType: 'text' | 'url' | 'audio';
  inputContent: string;
  platforms: string[];
  tone: string;
  postCount: number;
  projectName: string;
}

const defaultData: WizardData = {
  inputType: 'text',
  inputContent: '',
  platforms: ['LI', 'IG'],
  tone: 'Business-Punk',
  postCount: 14,
  projectName: '',
};

export default function ContentGeneratorWizard() {
  const [currentStep, setCurrentStep] = useState(1);
  const [wizardData, setWizardData] = useState<WizardData>(defaultData);

  const updateData = (partial: Partial<WizardData>) => {
    setWizardData((prev) => ({ ...prev, ...partial }));
  };

  return (
    <div>
      {/* Step Indicator */}
      <div className="flex items-center gap-0 mb-8">
        {steps.map((step, idx) => (
          <React.Fragment key={step.id}>
            <div className="flex items-center gap-3">
              <div
                className={`w-8 h-8 rounded flex items-center justify-center font-700 mono text-sm transition-all ${
                  currentStep === step.num
                    ? 'bg-accent text-black'
                    : currentStep > step.num
                    ? 'bg-green-900 text-green-400 border border-green-700' :'bg-surface border border-border text-muted'
                }`}
              >
                {currentStep > step.num ? '✓' : step.num}
              </div>
              <div className="hidden sm:block">
                <p className={`text-xs font-700 uppercase tracking-wider ${currentStep === step.num ? 'text-accent' : currentStep > step.num ? 'text-green-400' : 'text-muted'}`}>
                  {step.label}
                </p>
                <p className="text-xs text-muted-2">{step.desc}</p>
              </div>
            </div>
            {idx < steps.length - 1 && (
              <div className={`flex-1 h-px mx-4 transition-all ${currentStep > step.num ? 'bg-green-700' : 'bg-border'}`} />
            )}
          </React.Fragment>
        ))}
      </div>

      {/* Step Content */}
      <div className="fade-in">
        {currentStep === 1 && (
          <WizardStep1Input
            data={wizardData}
            onUpdate={updateData}
            onNext={() => setCurrentStep(2)}
          />
        )}
        {currentStep === 2 && (
          <WizardStep2Configure
            data={wizardData}
            onUpdate={updateData}
            onBack={() => setCurrentStep(1)}
            onNext={() => setCurrentStep(3)}
          />
        )}
        {currentStep === 3 && (
          <WizardStep3Generate
            data={wizardData}
            onBack={() => setCurrentStep(2)}
          />
        )}
      </div>
    </div>
  );
}